import { render } from "./CouponProviderManage.vue?vue&type=template&id=2d6025a4&scoped=true"
import script from "./CouponProviderManage.vue?vue&type=script&lang=js"
export * from "./CouponProviderManage.vue?vue&type=script&lang=js"

import "./CouponProviderManage.vue?vue&type=style&index=0&id=2d6025a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6025a4"]])

export default __exports__